import React, { useEffect, useState } from 'react';
import coachImage from '../Assest/Untitled-design-1.webp';
import logo from '../Assest/Logo.webp';

const FreeMasterclass = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 mins in seconds

  useEffect(() => {
    const checkWidth = () => setIsMobile(window.innerWidth <= 768);
    checkWidth();
    window.addEventListener('resize', checkWidth);
    return () => window.removeEventListener('resize', checkWidth);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const minutes = String(Math.floor(timeLeft / 60)).padStart(2, '0');
  const seconds = String(timeLeft % 60).padStart(2, '0');

  return (
    <div
      style={{
        margin: 0,
        fontFamily: 'Outfit, sans-serif',
        background: 'linear-gradient(180deg, #000b3e 0, #020202 59%)',
        color: 'white',
      }}
    >
      {/* Header Logo + Contact */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '20px',
          marginLeft:'15px'
          
        }}
      >
        {/* Left - Logo */}
        <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-start' }}>
          <img
            src={logo}
            alt="Billionaire Aniket"
            style={{ width: '160px', borderRadius: '20px' }}
          />
        </div>

        {/* Right - Contact Us */}
        <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
          <a
            href="https://billionaireaniket.co.in/contact-us/"
            style={{
              backgroundColor: '#f6a500',
              padding: '12px 24px',
              borderRadius: '30px',
              color: '#fff',
              fontWeight: 'bold',
              textDecoration: 'none',
              fontSize: '16px',
              boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
              transition: 'all 0.3s ease',
              marginRight:'15px'
              
            }}
          >
            Contact Us
          </a>
        </div>
      </div>

      {/* Header Section */}
      <div style={{ textAlign: 'center', padding: isMobile ? '30px 15px' : '40px 20px' }}>
        <div
          style={{
            border: '1px solid rgba(255, 255, 255, 0.2)',
            color: 'white',
            borderRadius: '40px',
            padding: '12px 20px',
            fontSize: '15px',
            fontWeight: '500',
            display: 'inline-block',
            background: 'transparent',
            letterSpacing: '0.5px',
          }}
        >
          2 Days Scientific Manifestation Masterclass
        </div>

        <h1 style={{ color: 'white', fontSize: isMobile ? '20px' : '36px', lineHeight: 1.4 }}>
          केवळ पैसाच नाही,<span style={{ color: '#F8C74B' }}>
            {' '}
            तर उत्तम आरोग्य, उत्तम करिअर आणि उत्तम <br /> नातेसंबंध{' '}
          </span>{' '}
          Law Of Attraction ने आकर्षित करू शकता.<span style={{ color: '#F8C74B' }}>
            {' '}
            सर्व काही <br /> शक्य आहे!{' '}
          </span>
        </h1>
        <p style={{ fontSize: isMobile ? '16px' : '18px', marginTop: '10px' }}>
          तुमच्या नकारात्मक विचारांमुळे तुमच्या यशाला ब्रेक लागतोय का ?
        </p>
      </div>

      {/* Main Section */}
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          flexDirection: isMobile ? 'column' : 'row',
          justifyContent: 'center',
          alignItems: isMobile ? 'center' : 'flex-start',
          padding: '0 20px',
        }}
      >
        {/* Left Image */}
        <div
          style={{
            flex: 1,
            minWidth: '300px',
            textAlign: 'center',
            marginBottom: isMobile ? '30px' : '0',
          }}
        >
          <img
            src={coachImage}
            alt="Coach"
            style={{
              width: isMobile ? '200px' : '250px',
              height: isMobile ? '200px' : '250px',
              objectFit: 'cover',
            }}
          />
          <div
            style={{
              backgroundColor: '#000',
              borderRadius: '12px',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              maxWidth: '400px',
              margin: '0px auto 0',
              padding: '15px',
            }}
          >
            <h2 style={{ margin: 0, color: 'white', fontSize: '18px' }}>Billionaire Aniket</h2>
            <p style={{ marginTop: '10px', fontSize: '14px' }}>
              Certified Life Coach & Trainer.
              <br />
              Founder Of Billionaire Aniket Healing & Coaching LLP
            </p>
          </div>
        </div>

        {/* Right Info Boxes */}
        <div style={{ flex: 1, minWidth: '300px', padding: '20px' }}>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
              gap: '20px',
              justifyContent: 'center',
            }}
          >
            {[
              {
                icon: '📅',
                label: 'Date',
                value: (
                  <>
                    12th & 13th July
                    <br />
                    <span style={{ color: '#F8C74B' }}>Sat & Sun</span>
                  </>
                ),
              },
              { icon: '⏰', label: 'Time', value: '7:30 to 9:30 PM' },
              { icon: '🎥', label: 'Venue', value: 'Zoom' },
              { icon: '🌐', label: 'Language', value: 'Marathi' },
            ].map((item, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  borderRadius: '20px',
                  padding: '15px',
                  color: 'white',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                }}
              >
                <span style={{ fontSize: '24px', color: '#fbbc04', marginRight: '10px' }}>
                  {item.icon}
                </span>
                <div>
                  <div style={{ fontSize: '14px', color: 'white' }}>{item.label}</div>
                  <div style={{ fontSize: '18px', fontWeight: 'bold' }}>{item.value}</div>
                </div>
              </div>
            ))}
          </div>

          <div style={{ textAlign: 'center', marginTop: '40px' }}>
            <button
              style={{
                background: 'linear-gradient(49.12deg, #ffc74b 0, #e39600 22%)',
                color: 'white',
                fontSize: isMobile ? '18px' : '20px',
                padding: isMobile ? '10px 40px' : '25px 80px',
                border: 'none',
                borderRadius: '20px',
                fontWeight: 'bold',
                cursor: 'pointer',
                width: isMobile ? '100%' : 'auto',
              }}
            >
              Join The 2 Day Workshop for ₹199 &nbsp;
              <span style={{ textDecoration: 'line-through', opacity: 0.8 }}>₹999</span>
            </button>
            <p
              style={{
                marginTop: '10px',
                color: 'white',
                fontSize: '16px',
                fontFamily: 'outfit,sans-serif',
                fontStyle: 'italic',
              }}
            >
              Registrations End on <span style={{ fontWeight: 'bold', color: 'red' }}>11 JUL</span>
              <br />
              100% मनी बॅक गॅरंटी | समाधानी नसल्यास
            </p>
          </div>
        </div>
      </div>

      {/* Footer Stats */}
      <div
        style={{
          textAlign: 'center',
          margin: '20px 20px 20px',
          fontSize: '18px',
          paddingTop: '5px',
        }}
      >
        16,439 पुनरावलोकनांपैकी 4.9 रेट केले &nbsp; | &nbsp; 20,000+ यशस्वी बदल &nbsp; | &nbsp; 1
        Lakh मराठी लोकांचे ध्येय.
      </div>

      {/* Countdown */}
      <div
        style={{
          textAlign: 'center',
          padding: '5px 20px',
          
        }}
      >
        <h2 style={{ fontSize: '22px' }}>Register In Next 15 Mins</h2>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '20px',
            marginTop: '20px',
            marginBottom: '50px',
          }}
        >
          {[minutes, seconds].map((value, index) => (
            <div
              key={index}
              style={{
                background: '#e39600',
                color: '#fff',
                padding: '15px',
                borderRadius: '8px',
                fontSize: '24px',
                fontWeight: 'bold',
                minWidth: '80px',
              }}
            >
              {value}
              <div style={{ fontSize: '14px', marginTop: '5px' }}>
                {index === 0 ? 'MINUTES' : 'SECONDS'}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FreeMasterclass;
